import React from 'react'

import AboutBrief from './AboutBrief'
import Banner from './Banner'
import ProductsBrief from './ProductsBrief'
import AreaOfInterest from './AreaOfSupply'

export default function Home() {
    return (
        <>
            <div className="main">
                <Banner />
                <AboutBrief />
                <ProductsBrief />
                <AreaOfInterest />
            </div>
        </>
    )
}
